<template>
  <div class="sidebar sidebar-astrology">
    <div class="user" style="z-index: 3">
      <div class="photo photo-full text-center mt-5 mb-4">
        <img
          src="@/assets/images/astrology/av-logo-text.png"
          id="" class="logo-img admin-nav-logo-img"
        />
        <img src="@/assets/images/astrology/av-logo.png" class="logo-img-mini admin-nav-logo-img"/>
      </div>
    </div>
    <div class="sidebar-wrapper">
      <ul class="nav">
        <li class="nav-item">
          <router-link to="/astrology_ventures/admin/dashboard" class="nav-link d-flex">
            <img
              class="my-nav-icon my-nav-icon-grey"
              src="@/assets/images/astrology/dashboard-icon.png"
              alt=""
            />
            <img
              class="my-nav-icon my-nav-icon-top"
              src="@/assets/images/astrology/dashboard-icon-active.png"
              alt=""
            />
            <p>Dashboard</p></router-link
          >
        </li>
        <li class="nav-item">
          <router-link to="/astrology_ventures/admin/my_studio" class="nav-link d-flex">
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-grey"
              src="@/assets/images/astrology/my-studio-icon.png"
              alt=""
            />
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-top"
              src="@/assets/images/astrology/my-studio-icon-active.png"
              alt=""
            />
            <p>My Studio</p>
          </router-link>
        </li>
         <li class="nav-item">
          <router-link to="/astrology_ventures/admin/content_management" class="nav-link d-flex">
            <img
              class="my-nav-icon my-nav-icon-grey"
              src="@/assets/images/astrology/content-icon.png"
              alt=""
            />
            <img
              class="my-nav-icon my-nav-icon-top"
              src="@/assets/images/astrology/content-icon-active.png"
              alt=""
            />
            <p> Manage App</p></router-link
          >
        </li>
        <li class="nav-item">
          <a class="nav-link d-flex" href="">
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-grey"
              src="@/assets/images/astrology/customers-icon.png"
              alt=""
            />
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-top"
              src="@/assets/images/astrology/customers-icon-active.png"
              alt=""
            />
            <p>Customers</p>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link d-flex" href="">
            <img
              class="my-nav-icon my-nav-icon-grey"
              src="@/assets/images/astrology/marketing-icon.png"
              alt=""
            />
            <img
              class="my-nav-icon my-nav-icon-top"
              src="@/assets/images/astrology/marketing-icon-active.png"
              alt=""
            />
            <p>Marketing</p>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link d-flex" href="" @click="logout">
            <img
              class="my-nav-icon my-nav-icon-grey"
              src="@/assets/images/astrology/logout-icon.png"
              alt=""
            />
            <img
              class="my-nav-icon my-nav-icon-top"
              src="@/assets/images/astrology/logout-icon-active.png"
              alt=""
            />
            <p>Logout</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "SidebarAstrology",
  data() {
    return {};
  },
  methods: {
    logout() {
      console.log("logoutt astrology admin");
      //  console.log(this.$children)
      // this.$confirm({
      //   title: 'Are you sure?',
      //   message: 'Are you sure you want to logout?',
      //   button: {
      //     yes: 'Yes',
      //     no: 'Cancel'
      //   },
      //   callback: confirm => {
      //     if (confirm) {
      localStorage.removeItem("user");
      localStorage.removeItem("customer");
      //  App.isLogin = false;
      this.$router.go({ name: "AstrologyLogin", params: { type: "admin" } }).catch(()=>{});
      // console.log(localStorage);
      //     }
      //   }
      // })
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/partials/admin_sidebar_astrology.vue